import styled from "styled-components";

export const MainContainer = styled.section`
  width: 100%;
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  margin-bottom: 50px;
`;
export const ItemsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  max-width: 200px;
  /* margin-left: 32px; */
`;

export const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0px 5px;
  /* flex-direction: column; */
  align-items: center;
`;

export const Logo = styled.img`
  width: 140px;
  margin-bottom: 10px;
  /* margin-left: 20px; */
`;

export const LinkItem = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: #fff;
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const Title = styled.h1`
  font-size: 5.625rem;
  color: #fff;
  font-family: emoji;
  /* position: absolute;
  top: -33px; */
`;

export const Subject = styled.p`
  font-size: 24px;
  color: #fff;
  font-style: italic;
`;
